export type FinanceApplicationModel = {
  agency_payment_method_id?: number,
  approved?: boolean,
  cache_key: number,
  campaign_contribution_id?: number,
  data?: any,
  dates?: {
    created: {
      date_time: string,
    },
    updated: {
      date_time: string,
    },
  },
  id: number,
  owner_id: number,
  owner_type: string,
  subject_id: number,
  subject_type: string,
  total?: number,
}

export type FinanceApplicationRequestOptions = {}

const state = {
  agency_payment_method_id: undefined,
  create_contribution: true,
  in_person: false,
  owner_id: undefined,
  owner_type: '',
  subject_id: undefined,
  subject_type: '',
  total: '',
}

export const requiredFields = [
  { key: 'agency_payment_method_id' },
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'subject_id' },
  { key: 'subject_type' },
  { key: 'total' },
]

export default state
